/** Türkçe sözlük · rapor. Şekli bu dosya tanımlar; öteki diller ona bağlıdır. */
export const rapor = {
  /** Varlık Dökümü ekranı (`screens/ReportScreen.tsx`). */
  ekran: {
    baslik: "Varlık Dökümü",
    aciklama: "Portföyün değeri, maliyeti, gerçekleşmiş getirisi — şeffaf: her değerin nereden geldiği görünür.",
    tarihItibariyla: "Şu tarih itibarıyla",
    gecmisGun: "Geçmiş bir güne bakmak",
    bugun: "Bugün",
    raporParaBirimi: "Rapor para birimi",
    buguneDon: "Bugüne dön",
    degerleniyor: "Portföy değerleniyor…",
  },

  bos: {
    baslik: "Değerlenecek bir şey yok",
    aciklama: "Kasada hareket olduğunda portföyün değeri, maliyeti ve gerçekleşmiş getirisi burada görünür.",
  },

  /** "<tarih> günü itibarıyla, <TRY> cinsinden." — tarih ve kod kalın, aralarda bu parçalar. */
  ust: {
    onEk: "",
    ara: " günü itibarıyla, ",
    sonEk: " cinsinden.",
    nakitKapali: " Nakit takibi kapalı (Ayarlar).",
  },

  eksik: {
    baslik: "Bu toplam eksik",
    metin:
      'Aşağıdaki pozisyonlar değerlenemediği için toplamlara GİRMEDİ. Toplamı "portföyün değeri" diye okumayın — eksik olduğu kadarıyla okuyun.',
  },

  /** Özet kartları. */
  kart: {
    bolum: "Toplamlar",
    piyasaDegeri: "Piyasa değeri",
    gunlukGetiri: "Günlük getiri",
    maliyet: "Maliyet",
    gerceklesmemisKazanc: "Gerçekleşmemiş kazanç",
    gerceklesmisKazanc: "Gerçekleşmiş kazanç",
    nakitAkisiNet: "Nakit akışı (net)",
    gerceklesmisGetiri: "Gerçekleşmiş getiri",
    asilGetiri: "Asıl getiri",
    netNakitHareketi: "Net nakit hareketi",
    yillikKarsilik: "Yıllık karşılık",
    kesilenVergi: "Kesilen vergi",
    toplamMaliyet: "Toplam maliyet",
    toplamVarlik: "Toplam varlık",
    getiri: "Getiri",
    mevduatKarsiligi: "Mevduat karşılığı",
    agirlikliOrtalama: "ağırlıklı ortalama ",
    sonIslemGunu: (tarih: string) => `son işlem günü ${tarih}`,
    gelir: "gelir: ",
    gider: " · gider: ",
    yillik: "yıllık ",
    gunSonEk: (_n: number) => " gün",
    netNakitAciklama:
      "Kasanın bütün satırlarının nakde etkisi. BAKİYE DEĞİL: açılış tutarını yazmadıysanız sonuç negatiftir ve bu doğrudur — eksi, kasaya girmemiş bir para kaynağı olduğunu söyler. Açılışı bir yatırma satırı olarak yazarsanız bu değer kendiliğinden bakiyeye döner.",
    kovaSonEk: (_n: number) => " kova (hesap × para birimi)",
  },

  /** Formül satırlarının terim adları ve oranların payda adları. */
  terim: {
    deger: "değer",
    maliyet: "maliyet",
    satisKazanci: "satış kazancı",
    degerNakitDahil: "değer (nakit dahil)",
    yatirilanCekilen: "yatırılan − çekilen",
    oncekiGunDegeri: "önceki günün değeri",
    cepten: "cepten çıkan para",
    satilan: "satılan partilerin maliyeti",
    faiz: "faiz",
    temettuFaiz: "temettü/faiz",
    masraf: "masraf",
    payda: "payda",
    adetCarpi: " adet × ",
    gunGetirisi: (tarih: string) => `${tarih} getirisi`,
    bugunkuGetiri: "bugünkü getiri",
    toplamVarlik: "toplam varlık",
    toplamMaliyet: "toplam maliyet",
  },

  nakit: {
    bolum: "Net nakit hareketi",
    eksikBaslik: "Nakit toplamı eksik",
    eksikMetin:
      'Aşağıdaki kovalar toplama GİREMEDİ. Toplam bu yüzden hiç yayımlanmıyor — eksik bir toplamı "net nakit" diye göstermek, değerin yanındaki uyarının görülmediği her yerde yanlış okunur.',
    kasaSonHareket: (ref: string, tarih: string) => `kasa ${ref} · son hareket ${tarih}`,
    tabloBasligi: "Hesap ve para birimi başına net nakit hareketi",
    hesap: "Hesap",
    paraBirimi: "Para birimi",
    netHareket: "Net hareket",
    karsiligi: (kod: string) => `${kod} karşılığı`,
    okunamayanSatir: (n: number) =>
      `${n} satırın tutarı okunamadı: kodlama kuralı quantity = 1, price = tutar diyor ama çarpım sıfır çıkıyor.`,
    turKirilimi: "Tür kırılımı",
    netYok: "Kovanın neti hesaplanamadığı için karşılığı da yok.",
    kurYok: (kaynak: string, hedef: string, tarih: string) =>
      `${kaynak} → ${hedef} kuru ${tarih} gününde bulunamadı. Soldaki değer DOĞRU; çevrilemeyen yalnızca karşılığı.`,
  },

  balon: {
    neden: "Bu değer niçin yok",
    oranYok: "Oran yok: payda sıfır ya da bilinmiyor.",
    bayat: "Bayat ölçüm — bu değer nereden geldi?",
    nasil: "Bu değer nasıl hesaplandı?",
    motorSoylemedi: "Motor bu değerin niçin olmadığını söylemedi — bu bir kusurdur, bildirin.",
  },

  dayanak: "Değerin dayanağı",
  /** Seans dışı fiyatın türü (bilgi; anormallik değil). */
  seans: {
    pre: "seans öncesi",
    post: "seans sonrası",
    /** Gece fiyatının işlem saati kaynakta yok: an, merkezin sorduğu an. */
    night: (an: string) => `gece seansı · ${an} itibarıyla`,
  },

  damga: {
    rapor: "Rapor damgaları",
    pozisyon: "Bu pozisyonun damgaları",
  },

  tablo: {
    gorunumGrubu: "Telefonda görünüm",
    gorunum: "Görünüm:",
    tablo: "Tablo",
    kart: "Kart",
    satilmis: (n: number) => `Tamamı satılmış ${n} varlık:`,
    goster: "Göster",
    toplamlarIcerir: "· Toplamlar onları her durumda içerir.",
    deger: (kod: string) => `Değer (${kod})`,
    maliyet: (kod: string) => `Maliyet (${kod})`,
    baslik: "Pozisyon değerlemeleri",
    varlik: "Varlık",
    miktar: "Miktar",
    birimFiyat: "Birim fiyat",
    gunluk: "Günlük / %",
    mevcutGetiri: "Mevcut getiri",
    gerceklesmis: "Gerçekleşmiş",
    nakitAkisi: "Nakit akışı",
    gercGetiri: "Gerç. getiri",
    yillik: "Yıllık",
    agrYas: "ağr. yaş",
    yillikAgrYas: "Yıllık · ağr. yaş",
    damga: "Damga",
    pay: "Pay",
    seciliKapsamda: "seçili kapsamda",
    paySeciliKapsamda: "Pay · seçili kapsamda",
    /** Sütun başlığındaki sıralama okunun ekran okuyucu adı (28.10.2026). */
    sirala: (ad: string) => `${ad} sütununa göre sırala`,
    paydaEksik:
      "Değeri ölçülemeyen bir varlık var. Paylar yalnızca değeri ölçülebilen varlıkların toplamına göre; o varlığın satırında payın neden olmadığı yazıyor.",
    gizle: "Gizle",
  },

  yillik: {
    agrYasOnEk: "ağr. yaş ",
    gunSonEk: (_n: number) => " gün",
    nasil: "Yıllık karşılık nasıl hesaplandı?",
    getiriCarpi: " getiri × 365 ÷ ",
    /** Biçimlenmiş sayı ve ham değeri (çoğul için). */
    gun: (sayi: string, _n: number) => `${sayi} gün`,
    payda: "Payda: ",
    cepten: " cepten çıkan para",
    geriYatirilanOnEk: " (geri yatırılan ",
    geriYatirilanSonEk: " hariç)",
  },

  gunluk: {
    sonGunAciklama: (tarih: string) =>
      `Bugün değer değişmedi; gösterilen, son işlem günü ${tarih} tarihinin getirisi.`,
    satirlarKarisik:
      "Bazı satırlar son işlem günlerini gösteriyor; bu toplam yalnızca bugünün değişimi, satırların toplamı onu tutmaz.",
    kurEtkisi: "içinden kur etkisi: ",
    sonIslemGunu: (tarih: string) => `Son işlem günü ${tarih}`,
  },

  ayrinti: {
    birimFiyat: "Birim fiyat",
    kesilenVergi: "Kesilen vergi",
    kesintiYok: "Kesinti bilgisi olan hareket yok.",
    acikPartiler: "Açık partiler (FIFO)",
    edinme: "Edinme",
    miktar: "Miktar",
    maliyet: "Maliyet",
    not: "Not",
    maliyetBilinmiyor: "maliyet bilinmiyor — sıfır sayılmadı",
    satislar: "Satışlar — hangi partiden ne kadar",
    /** Satış satırı: "<tarih> · <tür> · <adet> adet · hasılat <x> · maliyet <y> · kazanç <z>". */
    adetHasilat: " adet · hasılat ",
    maliyetAra: " · maliyet ",
    kazancAra: " · kazanç ",
    maliyetEksik: "maliyet eksik",
    partisinden: " partisinden ",
    adetMaliyet: " adet, maliyet ",
    bilinmiyor: " (bilinmiyor)",
  },

  nakitDokumu: {
    yok: "Bu varlıkta temettü, faiz ya da masraf hareketi yok.",
    baslik: "Nakit akışı dökümü",
    gelir: "gelir ",
    gider: " · gider ",
    net: " · net ",
    tarih: "Tarih",
    tur: "Tür",
    tutar: "Tutar",
    stopaj: "Stopaj",
    durum: "Durum",
    okunamadi: "okunamadı",
    miktarYazilmamis: "miktar yazılmamış — satır toplama girmedi",
    toplamaGirdi: "toplama girdi",
  },

  /** Pozisyonlar ekranı (`screens/PositionsScreen.tsx`). */
  pozisyonlar: {
    baslik: "Pozisyonlar",
    aciklama: "Hareketlerden türetilen ham miktarlar.",
    tarihItibariyla: "Şu tarih itibarıyla",
    buguneDon: "Bugüne dön",
    karZararYok: "Bu ekranda kâr/zarar yok",
    karZararMetni:
      "Aşama 1 yalnızca miktarları gösterir. Maliyet, getiri ve değerleme hesapları şirket olayları ve kur verisi olmadan yanlış çıkar — bunlar Aşama 3'te geliyor. Buradaki miktarlar da ham toplamdır: bölünme/bedelsiz düzeltmesi UYGULANMAMIŞTIR.",
    hesaplaniyor: "Pozisyonlar hesaplanıyor…",
    bosBaslik: "Pozisyon yok",
    bosAciklama: "Miktar taşıyan bir hareket (alış, satış, devir, bedelsiz) girildiğinde burada görünür.",
    tabloBasligi: "Ham pozisyonlar",
    varlik: "Varlık",
    baglama: "Bağlama",
    hamMiktar: "Ham miktar",
    paraBirimi: "Para birimi",
    ilkIslem: "İlk işlem",
    sonIslem: "Son işlem",
    hareket: "Hareket",
    izlenen: "İzlenen araç",
    elle: "Elle",
  },

  /** "Temettü hariç" etiketi (`components/TemettuHaric.tsx`). */
  temettuHaric: {
    balon: "Temettüler kural gereği hesaba katılmadı; sonuç fiyat getirisidir.",
    neden: "Temettü hariç — neden?",
    etiket: "temettü hariç",
  },

  /** ⓘ başlıkları (`ui/BilgiIkonu.tsx`); formül metni sözleşmeden. */
  bilgi: {
    nasil: (ad: string) => `${ad} nasıl hesaplanır?`,
    uyariVar: (ad: string) => `${ad} — uyarı var; nasıl hesaplanır?`,
  },
};
